import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import type { PendingProfile } from './types';

const personalHealthProfileSlice = createSlice({
  initialState,
  name: 'personalHealthProfile',
  reducers: {
    clearPendingProfile: (state) => {
      state.pendingProfile = initialState.pendingProfile;
    },
    setPendingProfile: (state, action: PayloadAction<PendingProfile>) => {
      state.pendingProfile = action.payload;
    },
  },
});

export const { actions: personalHealthProfileAction } = personalHealthProfileSlice;

export default personalHealthProfileSlice.reducer;
